import { EavAttributeFormDto, type EavAttributeFormInterface } from '@zaoblako/shared/modules/eav/dtos/attribute/eav-attribute-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { EavDtoKeysEnum } from '@zaoblako/shared/modules/eav/enums/eav-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { EavCheckersEnum } from '@zaoblako/shared/modules/eav/enums/eav-checkers.enum';

import * as yup from 'yup';

/** EAV entity type create and update APIs request body - DTO signature */
export interface EavEntityTypeFormInterface {
  /** EAV entity type display name */
  name: string;
  /** Attributes belongs to this entity type */
  attributes: EavAttributeFormInterface[];
}

/** EAV entity type create and update APIs request body - DTO schema */
export const EavEntityTypeFormDto = SerdeDtoClass.create<EavEntityTypeFormInterface>(EavDtoKeysEnum.EAV_ENTITY_TYPE_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup.string(),
  },
  attributes: {
    optional: true,
    label: 'Поля',
    nested: EavAttributeFormDto,
    checkers: [EavCheckersEnum.EAV_ATTRIBUTE_ASSERT_EXISTS_BY_DTO],
    serializer: (_, nested) => yup
      .array(nested)
      .min(1, DtoMessageEnum.EMPTY_ARRAY),
  },
});
